
import React, { Component } from 'react';
import StripePaymentContainer from "./stripePayment/stripePaymentContainer";

class PaymentComponent extends Component 
{
    render()
    {
        return <StripePaymentContainer amount={this.props.amount} onDismiss={this.props.onDismiss}/>
    }
}

export default PaymentComponent;